<template>
  <div class="okredit">
    <checker-offers-block :offers="checkerDisplayOffers" />
    <template v-if="isSwiperEnabled">
      <div class="showcase-wrapper">
        <div class="swiper-pagination" ref="pagination"></div>
        <div class="swiper-text__label">Листайте влево</div>
        <div class="swiper showcase-swiper" ref="swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="offer in mobileSwiperDisplayOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
              <div class="card okredit-offer-card">
                <div class="card-top">
                  <div class="card-top__logo">
                    <img :src="'https://zanimakus.ru' + offer.logo" :alt="offer.name || offer.title || ''" />
                  </div>
                  <h3 class="card-top__name">{{ offer.name || offer.title }}</h3>
                </div>

                <div class="card-amount">
                  <span class="card-amount__label">Сумма до</span>
                  <strong class="card-amount__value">{{ numberFormat(offer.amount) }} ₽</strong>
                </div>

                <div class="card-info">
                  <div class="card-info__row">
                    <span class="card-info__label">Срок</span>
                    <span class="card-info__value">до {{ offer.period }} дней</span>
                  </div>
                  <div class="card-info__row">
                    <span class="card-info__label">Займ без %</span>
                    <span class="card-info__value"
                          :class="offer.without_percent ? 'card-info__value--yes' : 'card-info__value--no'">
                      {{ offer.without_percent ? 'Да' : 'Нет' }}
                    </span>
                  </div>
                  <div class="card-info__row">
                    <span class="card-info__label">Решение</span>
                    <span class="card-info__value">Индивидуально</span>
                  </div>
                </div>

                <div class="card-btn" @click="openLinks(offer)">
                  <button type="button">
                    <span>Посмотреть условия</span>
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M4 12h16m-6-6 6 6-6 6" />
                    </svg>
                  </button>
                </div>

                <p class="card-note">Ставку и ПСК проверьте в договоре выбранного кредитора.</p>
              </div>
            </div>
          </div>
          <button class="showcase-nav prev" ref="prevBtn" :class="{ hidden: !hasMovedFromFirst }" type="button" aria-label="Предыдущее предложение">‹</button>
          <button class="showcase-nav next" ref="nextBtn" type="button" aria-label="Следующее предложение">›</button>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="showcase-wrapper showcase-wrapper--no-swiper">
        <template v-for="offer in showcaseOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link">
          <div class="card okredit-offer-card">
            <div class="card-top">
              <div class="card-top__logo">
                <img :src="'https://zanimakus.ru' + offer.logo" :alt="offer.name || offer.title || ''" />
              </div>
              <h3 class="card-top__name">{{ offer.name || offer.title }}</h3>
            </div>

            <div class="card-amount">
              <span class="card-amount__label">Сумма до</span>
              <strong class="card-amount__value">{{ numberFormat(offer.amount) }} ₽</strong>
            </div>

            <div class="card-info">
              <div class="card-info__row">
                <span class="card-info__label">Срок</span>
                <span class="card-info__value">до {{ offer.period }} дней</span>
              </div>
              <div class="card-info__row">
                <span class="card-info__label">Займ без %</span>
                <span class="card-info__value"
                      :class="offer.without_percent ? 'card-info__value--yes' : 'card-info__value--no'">
                  {{ offer.without_percent ? 'Да' : 'Нет' }}
                </span>
              </div>
              <div class="card-info__row">
                <span class="card-info__label">Решение</span>
                <span class="card-info__value">Индивидуально</span>
              </div>
            </div>

            <div class="card-btn" @click="openLinks(offer)">
              <button type="button">
                <span>Посмотреть условия</span>
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M4 12h16m-6-6 6 6-6 6" />
                </svg>
              </button>
            </div>

            <p class="card-note">Ставку и ПСК проверьте в договоре выбранного кредитора.</p>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";
import * as Data from "../assets/js/data_params.js";
import offerBucketsMixin from "../assets/js/offerBucketsMixin.js";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";
import CheckerOffersBlock from "./CheckerOffersBlock.vue";

export default {
  name: "ShowcaseOkredit",
  mixins: [offerBucketsMixin, mobileSwiperMixin],
  components: { CheckerOffersBlock },

  props: {
    offers: Array,
    checkerOffers: Array,
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    filteredOffers() {
      return this.getInlineOrderedOffers(this.displayedOffers);
    },

    checkerDisplayOffers() {
      return this.getCheckerDisplayOffers();
    },

    showcaseOffers() {
      return this.getInlineShowcaseOffers(this.filteredOffers);
    },
  },

  methods: {

    numberFormat(n) { return Functions.numberFormat(n); },

    openLinks(offer) {
      window.open(offer.link, "_blank");
      offer.links.forEach(l => window.open(l, "_blank"));
    },

  }
};
</script>

<style lang="css">
@import url(../assets/css/okredit.scss);
</style>

<style lang="css">
.okredit .swiper-text__label {
  display: none;
}

@media (min-width: 768px) {
  .okredit > .showcase-wrapper > .swiper-pagination,
  .okredit > .showcase-wrapper .showcase-nav {
    display: none !important;
  }
}

@media (max-width: 767px) {
  .okredit > .showcase-wrapper > .swiper-text__label {
    display: block;
    width: 100%;
    margin: 0 0 14px;
    color: #748078;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
  }

  .okredit > .showcase-wrapper > .swiper-pagination {
    display: block;
    position: relative;
    inset: auto;
    width: min(100%, 360px);
    height: 5px;
    margin: 0 auto 12px;
    overflow: hidden;
    border-radius: 999px;
    background: #e2e8dc;
  }

  .okredit > .showcase-wrapper > .swiper-pagination .swiper-pagination-progressbar-fill {
    width: 100%;
    height: 100%;
    background: #173f3a;
    transform-origin: left center;
    transition: transform .25s ease;
  }

  .okredit > .showcase-wrapper > .showcase-swiper {
    position: relative;
    overflow: hidden;
    width: 100%;
    min-width: 0;
  }

  .okredit > .showcase-wrapper .swiper-slide {
    display: flex;
    justify-content: center;
    height: auto;
    box-sizing: border-box;
  }

  .okredit > .showcase-wrapper .showcase-nav {
    position: absolute;
    top: 50%;
    z-index: 50;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    padding: 0;
    transform: translateY(-50%);
    border: 1px solid #d6e0ce;
    border-radius: 50%;
    background: #173f3a;
    color: #fff;
    font: 26px/1 Arial, sans-serif;
    cursor: pointer;
    box-shadow: 0 3px 12px #173f3a18;
  }

  .okredit .showcase-nav.prev { left: 0; }
  .okredit .showcase-nav.next { right: 0; }
  .okredit .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}
</style>
